/* eslint-disable react-native/no-inline-styles */
import Box from '@/Atoms/Box';
import React, {useEffect, useState, isValidElement, useMemo} from 'react';
import {MaterialIcons} from '@expo/vector-icons';
import {
  Image,
  Pressable,
  Text,
  TouchableOpacity,
  View,
  useWindowDimensions,
} from 'react-native';
import useDashboardApi, {
  useDashboardApiQuery,
} from '@/Hooks/DashboardApi/dashboardApi';
import coins from '../../Assets/Images/Svgs/coinInRewards.svg';
import cursorClick from '../../Assets/Images/Svgs/cursorclick.svg';
import speedometer from '../../Assets/Images/Svgs/speedometer.svg';

import Feather from 'react-native-vector-icons/Feather';
import GemsSummaryComponent from './component/GemsSummary';
// import {vs} from '@/Utils/Dimensions';
import AntDesign from 'react-native-vector-icons/AntDesign';
import {styles} from './styles';
import TasksBox from './component/Tasks';
import ScoreCard from './component/Scorecard';
import useLoggedInUserStore from '@/Store/loggedInUserstore';
import GameReviewBox from './component/GameReview';
import MasterPuzzleBox from './component/MasterPuzzleBox';
import {useNavigation} from '@react-navigation/native';
import CCLoader from '@/Atoms/CCLoader';
import CCText from '@/Atoms/CCText';
import Reveal from '@/Atoms/Reveal';
import NudgeArrow from '@/Atoms/NudgeArrow';
import CoinsChip from './component/CoinsChip';
import FocusCards from './component/FocusCards';
import CurriculumPanel, {RailSkeleton} from './component/CurriculumPanel';
import ChessboardComponent from 'chessboard-package';

import FontAwesome5 from 'react-native-vector-icons/FontAwesome5';
import Ionicons from 'react-native-vector-icons/Ionicons';
import MaterialCommunityIcon from 'react-native-vector-icons/MaterialCommunityIcons';
import CCColors, {updateColorWithOpacity} from '@/Utils/CCColors';
import CCButton from '@/Atoms/CCButton';
import {ScreenName} from '@/navigators/StackConstants';
import {logEvent} from '@/Utils/GAEvents';
import useGAPageView from '@/navigators/useGAPageView';
import InfoIcon, {CustomInfoBox} from '@/Atoms/InfoIcon';
import Spacer from '@/Atoms/Spacer';
import {FontSizes, vs} from '@/Utils/Dimensions';
import {useMediaQuery} from '@/Hooks/useMediaQuery/useMediaQuery';
import Divider from '@/Atoms/Divider/Divider';
import CCPackageTableNew from '@/Atoms/CCPackageTableNew';
import {
  getLocalStorage,
  removeLocalStorage,
  setLocalStorage,
} from '@/Utils/CommonUtils';
import {OPACITY_0_2, OPACITY_1_0, PRO_PLAN_IDS} from '@/Utils/Constants';
import {GAMEPLAY_STRIP_CONTENT} from './helper';
import {
  useNonPersistedUserPlanStore,
  useUserPlanStore,
} from '@/Store/userPlanStore';
import useGetUserActivePlanApi from '@/Hooks/UserActivePlanApi/useGetUserActivePlan';
import summaryStore from '@/Store/summaryStore';
import useChessboardColorTheme from '@/Hooks/ChessboardColorTheme/useChessboardColorTheme';
import useRunAssesment from '@/Hooks/AssessmentApi/useRunAssesment';
import useAlertModalStore from '@/Store/AlertModalStore';
import GamePlayStripComponent from './component/GamePlayStripComponent';
import RunAssessment from '@/Components/RunAssessment';
import useGraphDimensionsStore from '../Assessments/components/AssessmentDetails/graphDimensionStore';
import BeginnerDashboard from './component/BeginnerDashboard/BeginnerDashboard';
import TournamentBanner from './component/TournamentBanner/TournamentBanner';
import TournamentReminder from './component/TournamentReminder';
import BannerCarousel from './component/BannerCarousel';
import LeaderboardPreview from './component/LeaderboardPreview';
import {usePrizeTournamentsApi} from '@/Hooks/GetTournaments/useGetPrizeTournaments';
import TournamentBanner2 from './component/TournamentBanner/TournamentBanner2';
import ConnectionModal from '../PlayChess/components/ConnectionModal';
import {capitalizeFirstLetter} from '../../Utils/CommonUtils';
import CsocPaidSetupDashboard from './component/CsocPaidSetupDashboard';
import usePersona from './usePersona';
import {dsIcons} from './designIcons';
import AnimatedBar from '@/Atoms/AnimatedBar';
import SkeletonBar from '@/Atoms/SkeletonBar';
import ClubActivityCard from './component/ClubActivity';
import LiveActivityFeed from './component/LiveActivityFeed';
import TrainAndSolveGrid from './component/TrainAndSolveGrid';
import {radii} from '@/Utils/radius';

// import * as dayjs from 'dayjs';

function Dashboard({
  data: summaryData,
  isLoading,
  userData,
  // Unused now that the username prompt (its only consumer) is gone --
  // prefixed to satisfy no-unused-vars. Kept because Application still
  // passes it down; harmless to accept and ignore.
  setUserData: _setUserData,
  isBeginnerPlayer,
}) {
  // const [avatar, setAvatar] = useState(null);
  // const [gameForReview, setGameForReview] = useState(null);
  // const [puzzle, setPuzzle] = useState(null);
  // const [scorecards, setScorecards] = useState(null);
  // const [netCCPoints, setNetCCPoints] = useState(0);
  // const [masterPuzzle, setMasterPuzzle] = useState(null);

  const navigation = useNavigation();
  useGAPageView(ScreenName.Dashboard);
  const {
    persona,
    classes: personaClasses,
    resolving: personaResolving,
    webinarList,
    pastWebinarList,
  } = usePersona(!!isBeginnerPlayer, summaryData?.data?.user?.user_key);
  // "CSOC" isn't a backend flag — it's the persona engine's read of the user
  // actually having classes on user_webinar_detail.
  const isCsocPersona =
    persona === 'csoc_class_day' || persona === 'csoc_rest_day';
  // The persona depends on an async webinar fetch. Rendering a default persona
  // and swapping it ~1-2s later visibly flipped the hero copy, chip and banner
  // in front of the user, so persona-driven text waits for the real answer and
  // holds its space with skeletons meanwhile (no layout shift either way).
  const personaReady = !personaResolving;
  const {isMobile, isTablet, isMobileOrTab} = useMediaQuery();
  // useMediaQuery's isMobileOrTab only covers <=768, so every width above that
  // got the full desktop layout. At 1024 (iPad Pro portrait) the 70/30 band
  // leaves the leaderboard rail ~290px, which truncates names, medals and the
  // "YOUR POSITION TODAY" chip; the 1.55/1 rows are equally cramped. Treat
  // anything under 1280 as narrow and stack those rows instead.
  const {width: viewportWidth} = useWindowDimensions();
  const isNarrow = viewportWidth < 1280;
  // Layout-only flag: rows stack, but the richer desktop visuals stay.
  const stackRows = isMobileOrTab || isNarrow;
  const latestAssessmentDate = useGraphDimensionsStore(
    state => state.latestAssessmentDate,
  );
  const setUserEmail = useLoggedInUserStore(state => state.setEmail);
  const setUserGems = useLoggedInUserStore(state => state.setGems);
  const setUserId = useLoggedInUserStore(state => state.setUserId);
  const setUserLevel = useLoggedInUserStore(state => state.setLevel);
  const setUserAvatar = useLoggedInUserStore(state => state.setAvatar);
  const setUserIcon = useLoggedInUserStore(state => state.setIcon);
  const [isAssessmentLoading, setIsAssessmentLoading] = useState(false);
  const setStreakDetailsSummary = useLoggedInUserStore(
    state => state.setStreakDetailsSummary,
  );
  const setStreakConfig = useLoggedInUserStore(state => state.setStreakConfig);
  const chessboardColorTheme = useChessboardColorTheme();

  const [hoveredItemForGameplayCard, setHoveredItemForGameplayCard] =
    useState(0);
  // Measured height of the top band's left column, used to cap the pinned
  // leaderboard rail beside it.
  const [bandHeight, setBandHeight] = useState(0);
  const [calculationTooltip, setCalcultaionTooltip] = useState('');
  const [endgameTooltip, setEndgameTooltip] = useState('');
  const [middleGameTooltip, setMiddleGameTooltip] = useState('');
  const [openingTooltip, setOpeningTooltip] = useState('');
  const [assessmentDate, setAssessmentDate] = useState('');
  const [showReminder, setShowReminder] = useState(true);
  const {data: tournamentPrize} = usePrizeTournamentsApi(
    userData?.user_id,
    () => {},
    error => {
      console.error('Failed to fetch tournaments:', error);
    },
  );
  const tournamentPrizes = tournamentPrize?.data || [];

  console.log('userData: ', userData);

  useEffect(() => {
    setCalcultaionTooltip(
      summaryData?.data?.assessment?.score_tooltips?.calculation_depth_tooltip,
    );
    setEndgameTooltip(
      summaryData?.data?.assessment?.score_tooltips?.endgame_tooltip,
    );
    setMiddleGameTooltip(
      summaryData?.data?.assessment?.score_tooltips?.middlegame_tooltip,
    );
    setOpeningTooltip(
      summaryData?.data?.assessment?.score_tooltips?.opening_tooltip,
    );
    setAssessmentDate(
      summaryData?.data?.assessment?.created_time?.slice(0, 10),
    );
  }, [summaryData]);

  // const {mutate: getDashboardApi} = useDashboardApi(
  //   handleOnSuccessDashboardData,
  //   handleOnFailedDashboardData,
  // );

  // const {
  //   mutate: loadDashboard,
  //   data: validatedData,
  //   error: validatedError,
  //   isLoading,
  // } = useDashboardApi(handleOnSuccess, handleOnError);

  // const {isLoading, data} = useDashboardApiQuery();
  const data = summaryData?.data;
  const csocSetup = data?.csoc_setup_dashboard;
  // const {data, isUserLoggedIn, loading: isLoading} = summaryStore();
  useEffect(() => {
    const updateLocalStorage = async () => {
      try {
        await setLocalStorage(
          'user_details',
          JSON.stringify(data?.user),
          true,
          () => {},
        );
      } catch (error) {
        console.error('Failed to set local storage:', error);
      }
    };
    if (data?.streak_details) {
      setStreakConfig(data?.streak_details);
    }
    if (data?.streak_details_summary) {
      setStreakDetailsSummary(data?.streak_details_summary);
    }
    if (data?.avatar) {
      setUserAvatar(data?.avatar);
    }
    if (data?.user) {
      updateLocalStorage();
    }
  }, [data]);

  const userPlanStore = useUserPlanStore();
  const isPremiumUser = useMemo(
    () =>
      PRO_PLAN_IDS?.includes(
        userPlanStore?.planDetails?.user_subscription_details?.fields?.plan_id,
      ),
    [userPlanStore?.planDetails],
  );
  const handleOnSuccessGetPlan = data => {
    let planName = data?.data?.user_subscription_plan_name;
    // planName = planName.split(' ')[0];
    let plan = 'Free';
    if (planName.toLowerCase().includes('aspiring learners')) {
      plan = 'aspiringLearners';
    } else if (planName.toLowerCase().includes('aspiring champions')) {
      plan = 'aspiringChampions';
    }
    userPlanStore.setActivePlan(plan);
  };
  const handleOnErrorGetPlan = error => {
    console.log('error while fetching user active plan', error);
  };
  const {mutate: getActivePlan, data: planData} = useGetUserActivePlanApi(
    handleOnSuccessGetPlan,
    handleOnErrorGetPlan,
  );

  function sanitizeFEN(fen) {
    if (!fen) {
      return undefined;
    }
    return fen.replace(/\s\d\+\d/, ''); // Remove the check count (e.g., "2+0")
  }

  useEffect(() => {
    getActivePlan();
  }, []);
  if (isLoading) {
    return <CCLoader loading bgWhite />;
  }

  if (csocSetup?.show === true) {
    return <CsocPaidSetupDashboard setup={csocSetup} />;
  }

  const avatar = data?.avatar;
  const netCCPoints = data?.user?.net_score;
  const gameForReview = data?.game;
  const masterPuzzle = data?.master_puzzle;
  const puzzle = data?.puzzle;
  const scorecards = data?.scorecards;
  const parts = data?.master_puzzle?.username
    ?.split('|')
    ?.map((part: string) => part.trim());

  const perfStatsAgg = data?.perf_stats?.last_n_games_stats.reduce(
    (acc, current) => {
      return {
        blunders: acc?.blunders + current?.blunders,
        blunder_free_games:
          current.blunders == 0
            ? acc?.blunder_free_games + 1
            : acc?.blunder_free_games,
        blunders_in_less_than_ten_secs:
          acc?.blunders_in_less_than_ten_secs +
          current?.blunders_in_less_than_ten_secs,
        accuracy: acc?.accuracy + current?.accuracy,
      };
    },
    {
      blunders: 0,
      blunder_free_games: 0,
      blunders_in_less_than_ten_secs: 0,
      accuracy: 0,
    },
  );

  const puzzleOnFirstTryScore = Math.floor(
    (data?.perf_stats?.puzzles_on_first_try_last_n?.reduce((count, current) => {
      return current != -1 ? count + 1 : count;
    }, 0) *
      100) /
      data?.perf_stats?.puzzles_on_first_try_last_n.length,
  );

  const perfStatsLen = data?.perf_stats?.last_n_games_stats?.length;
  const perfStatsAvg = {
    blunder_free_games: Math.floor(
      (perfStatsAgg?.blunder_free_games * 100) / perfStatsLen,
    ),
    blunders_in_less_than_ten_secs: Math.floor(
      (perfStatsAgg?.blunders_in_less_than_ten_secs * 100) /
        perfStatsAgg?.blunders,
    ),
    accuracy: Math.floor(perfStatsAgg?.accuracy / perfStatsLen),
  };

  function goal(
    titleText,
    subTitleText,
    infoText,
    value,
    opts = {},
    target: Number | null = null,
    infoIcon = <></>,
    barColor = CCColors.Green,
  ) {
    const {isFirst = null, isLast = null, action = null} = opts;
    const barPct =
      value === '-' || isNaN(Number(value))
        ? 4
        : Math.max(4, Math.min(100, Number(value)));
    return (
      <View
        style={[
          isMobileOrTab ? styles.goalMobile : styles.goal,
          !isMobileOrTab && isFirst && {paddingLeft: 0},
          !isMobileOrTab && isLast && {borderRightWidth: 0},
        ]}>
        <View style={styles.goalHeader}>
          {infoIcon && (
            <Box style={styles.goalIcon}>{infoIcon}</Box>
          )}
          {/* <CCText style={[styles.goalTitle, {...OPACITY}]}>{titleText}</CCText> */}
          <InfoIcon
            style={styles.goalInfoIcon}
            color={CCColors.Primary.Brown}
            text={infoText}
          />
        </View>
        <View
          style={{
            flexDirection: 'row',
            justifyContent: 'space-between',
            alignItems: 'center',
            marginTop: 30,
          }}>
          <CCText style={[styles.goalNumber, {...OPACITY}]}>
            {value}
            {value != '-' && (
              <CCText
                fontWeight="500"
                size={12}
                style={{paddingLeft: 2, ...OPACITY}}
                color={CCColors.TextColor.Grey}>
                %
              </CCText>
            )}
          </CCText>
          {action && (
            <CCButton
              style={styles.goalAction}
              onPress={action.handler}
              contentContainerStyle={{
                paddingVertical: 6,
                paddingHorizontal: 12,
              }}>
              <CCText fontWeight="500" fontSize={14}>
                {action.text}
              </CCText>
            </CCButton>
          )}
        </View>
        <AnimatedBar
          percent={barPct}
          color={barColor}
          height={6}
          trackColor={CCColors.BorderLight}
          style={{marginTop: 8}}
        />
        <View>
          <CCText style={[styles.goalTitle, {...OPACITY}]}>{titleText}</CCText>
          {/* <InfoIcon style={styles.goalInfoIcon} text={infoText}></InfoIcon> */}
          <CCText
            style={[
              styles.goalSubTitle,
              isMobileOrTab && styles.goalSubTitleMobile,
            ]}>
            {subTitleText}
          </CCText>
        </View>
      </View>
    );
  }

  function headerColTextWithUnderline(
    el,
    i = 0,
    flex = 0.3,
    restart = false,
    end = false,
    tempTextStyle = {},
  ) {
    const marginLeft = restart ? 16 : 0;
    const marginRight = end ? 16 : 0;
    return (
      <View
        style={[
          {
            flex: flex,
            marginLeft: marginLeft,
            marginRight: marginRight,
          },
        ]}>
        {isValidElement(el) ? (
          <Box>{el}</Box>
        ) : (
          <CCText
            fontWeight="500"
            style={[styles.headerColText, {color: CCColors.Primary.Dark}]}
            fontSize={12}>
            {el}
          </CCText>
        )}
      </View>
    );
  }

  function headerColText(el, i = 0, flex = 0.3) {
    return (
      <View style={{flex: flex}}>
        {isValidElement(el) ? (
          el
        ) : (
          <CCText fontWeight="500" style={styles.headerColText}>
            {el}
          </CCText>
        )}
      </View>
    );
  }

  function colText(text, flex = 0.3) {
    return (
      <View
        style={[
          isMobileOrTab ? {} : styles.mL16,
          {
            flex: flex,
            paddingVertical: 16,
          },
        ]}>
        <CCText
          fontSize={isMobileOrTab && FontSizes[15]}
          fontWeight="500"
          style={isMobileOrTab ? {color: CCColors.Primary.Brown} : styles.mL2}>
          {text}
        </CCText>
      </View>
    );
  }

  const handleGameplayRedirection = () => {
    navigation.navigate(ScreenName.PlayChess);
  };

  const OPACITY =
    data?.user.learning_onboarding_status === 2 ? OPACITY_0_2 : OPACITY_1_0;

  return (
    <Box style={{backgroundColor: '#FAF6EB', height: '100vh'}}>
      <View style={[styles.container, isMobileOrTab && styles.containerMobile]}>
        <CCLoader loading={isAssessmentLoading} />
        {/* <TournamentBanner2 /> */}
        {/* On the persona dashboard the carousel lives inside the top band's
            left column (design: topRowStyle's first grid cell holds carousel →
            hero → trainers), so the leaderboard rail starts level with it.
            The beginner dashboard has no such band, so it keeps the
            full-width banner. */}
        {isBeginnerPlayer && (
          <Reveal delay={0} style={styles.fullRow}>
            <BannerCarousel
              isBeginnerPlayer={!!isBeginnerPlayer}
              classes={personaClasses}
              game={data?.game}
              assessmentDate={latestAssessmentDate || assessmentDate}
            />
          </Reveal>
        )}
        {tournamentPrizes?.length > 0 && showReminder && (
          <TournamentReminder
            tournament={tournamentPrizes}
            setShowReminder={setShowReminder}
          />
        )}

        {/* Top card with message of displaying information to be shown only if the onboarding status = 2, ie. games have not all been imported yet */}
        {isBeginnerPlayer ? (
          <BeginnerDashboard />
        ) : (
          <>
            {data.user.learning_onboarding_status === 2 && (
              <Box
                style={{flexDirection: 'row', flexBasis: '100%'}}
                onPress={handleGameplayRedirection}>
                <View
                  style={[
                    styles.card,
                    styles.goalsCard,
                    (isMobile || isTablet) && styles.mobileCard,
                    {
                      backgroundColor: updateColorWithOpacity(
                        CCColors.Primary.Default,
                        0.2,
                      ),
                      alignItems: 'center',
                    },
                  ]}>
                  <AntDesign
                    name="infocirlceo"
                    size={20}
                    color={CCColors?.Red}
                    // style={{marginRight: 20}}
                  />
                  <Spacer spacing={10} horizontal />
                  <CCText
                    style={{color: CCColors.Primary.Brown}}
                    fontSize={FontSizes[14]}>
                    Welcome to CircleChess! We are analysing your games and
                    getting your learning dashboard ready! This should take
                    about couple of hours and we will send you notification via
                    whatsapp when it completes. In the meantime, you can play
                    games, analyse offline games, use our trainers to get
                    better!
                  </CCText>
                </View>
              </Box>
            )}

            {/* 4a "Integrated Dashboard" top band — carousel + hero + Train &
                solve grid (70%) pinned beside the Daily Leaderboard (30%), so
                the rail starts level with the carousel. Design source:
                DashboardRevampContent.dc.html, topRowStyle. */}
            <Reveal
              delay={60}
              style={{
                flexDirection: stackRows ? 'column' : 'row',
                flexBasis: '100%',
                // Row (desktop): flex-start so the left column's measured
                // height is its own content height, not the row height the
                // taller rail sets — otherwise the rail height cap below can
                // never shrink it.
                // Column (narrow): alignItems governs WIDTH here, and
                // flex-start made children size to their content, so the
                // trainer grid and the banner wrapper grew past the viewport —
                // which is also why the carousel measured too wide and slid
                // off-screen. Stretch fills the available width instead.
                alignItems: stackRows ? 'stretch' : 'flex-start',
                // Reveal animates a transform, which makes each band its own
                // stacking context — so the Play card's time-control menu can
                // only escape this band if the band outranks the sections after
                // it. Without this the menu opens behind the next row.
                zIndex: 2,
              }}>
            <View
              onLayout={e => setBandHeight(e.nativeEvent.layout.height)}
              style={{
                flex: stackRows ? 1 : 0.7,
                // Explicit basis 0, matching every row child below (goalSection,
                // reviewGameCard, …). On an 'auto' basis the columns size to
                // their CONTENT first and only the leftover is split 0.7/0.3,
                // so the seam drifts with whatever the carousel happens to be
                // showing instead of sitting at a fixed 70%.
                flexBasis: stackRows ? 'auto' : 0,
                justifyContent: 'flex-start',
                minWidth: 0,
                // The 8px inset lives on the COLUMN, not on the sections inside
                // it. `flex` splits whatever is left after margins, so a row
                // whose children carry margin 8 (every row below this band)
                // divides W-32 while a margin-less column divides W — putting
                // the two seams 6.4px apart. Same margins here, same seam.
                marginHorizontal: 8,
              }}>
              {/* Negative inset cancels the 8px each SLIDE carries. That inset
                  has to stay (it's the gutter between slides mid-transition,
                  see BannerCarousel styles), but the column already provides
                  the page inset — without this the banner would sit 8px inside
                  the sections below it. */}
              <View style={{marginTop: 8, marginHorizontal: -8}}>
                <BannerCarousel
                  isBeginnerPlayer={!!isBeginnerPlayer}
                  game={data?.game}
                  assessmentDate={latestAssessmentDate || assessmentDate}
                  personaReady={personaReady}
                />
              </View>
              {/* The two things to put in front of you first: Class +
                  Assignment for a CSOC student, Play + Fun Challenge for
                  everyone else — see FocusCards.
                  zIndex here, not just on FocusCards' own internal section
                  style — THIS view is TrainAndSolveGrid's actual DOM sibling
                  (both direct children of the band column below), and a
                  z-index set only on a nested descendant doesn't help a
                  sibling comparison happening a level up: with neither
                  wrapper positioned, TrainAndSolveGrid simply painted on top
                  by being later in DOM order, clipping the Play card's open
                  time-control menu after its first row. */}
              <View style={{marginTop: 8, zIndex: 2}}>
                {personaReady ? (
                  <FocusCards
                    navigation={navigation}
                    isCsoc={isCsocPersona}
                    classes={personaClasses}
                    stacked={stackRows}
                  />
                ) : (
                  // Roughly the section's real height (header + cards +
                  // padding) so the page doesn't jump when it resolves.
                  <SkeletonBar width="100%" height={228} borderRadius={radii.panel} />
                )}
              </View>

              <Box style={{marginTop: 8, marginBottom: 8}}>
                {personaReady ? (
                  <TrainAndSolveGrid
                    navigation={navigation}
                    isCsoc={isCsocPersona}
                  />
                ) : (
                  // Both personas render a 4-card, 2-row grid now (CSOC:
                  // Trainers/Positions/Play/Fun Challenge; non-CSOC:
                  // Calculation/Intuition/Square/Positions) — same height
                  // either way, so there's no persona-dependent guess here.
                  <SkeletonBar width="100%" height={250} borderRadius={radii.panel} />
                )}
              </Box>
            </View>
            {/* The rail can't be capped by flex alone: its own content is what
                sets the row height, so it never shrinks. Pin it to the left
                column's measured height instead (design: the rail ends level
                with the Train & solve grid, rows scroll inside). */}
            <View
              style={{
                flex: stackRows ? undefined : 0.3,
                // Matches the left column — see the note there.
                flexBasis: stackRows ? 'auto' : 0,
                // NOT width:'100%' — this column carries marginHorizontal 8, so
                // 100% plus those margins overflows the row by 16px. Stretch
                // fills the space that's actually left.
                alignSelf: stackRows ? 'stretch' : undefined,
                minWidth: 0,
                // Mirrors the left column — see the note there.
                marginHorizontal: 8,
                // Only cap the rail's height when it actually sits beside the
                // band; stacked, it should size to its content.
                ...(!stackRows && bandHeight ? {height: bandHeight} : {}),
              }}>
              {/* CSOC students get their class curriculum in this slot instead
                  of the daily leaderboard: they're here for the course, and
                  "which session am I on" is the more useful glance. Everyone
                  else keeps the leaderboard.

                  Always compact: the design's board card stacks rows then the
                  yellow "YOUR POSITION TODAY" footer at every breakpoint. The
                  side-by-side body belongs to the standalone leaderboard card,
                  and at 720-1280 it squeezed both halves. */}
              {!personaReady ? (
                // Which panel belongs here isn't known until the webinar fetch
                // resolves. Defaulting to the leaderboard meanwhile meant CSOC
                // students watched it load and settle, then get replaced by the
                // curriculum — so hold the shape with a neutral skeleton and
                // commit once, same approach as the hero copy and banners.
                <RailSkeleton />
              ) : isCsocPersona ? (
                <CurriculumPanel
                  past={pastWebinarList}
                  upcoming={webinarList}
                  stacked={stackRows}
                />
              ) : (
                <LeaderboardPreview compact />
              )}
            </View>
            </Reveal>

            <Reveal delay={120} style={styles.fullRow}>
            <View style={{flexDirection: 'row', flexBasis: '100%'}}>
              {perfStatsLen > 0 && (
                <View
                  style={[
                    styles.goalsCard,
                    // mobileCard = flexDirection column. Applied at narrow
                    // widths too: side by side, the 4 goal tiles and the
                    // 4 assessment stats both get far too little room.
                    stackRows && styles.mobileCard,
                  ]}>
                  <View
                    style={[
                      styles.card,
                      isMobileOrTab
                        ? styles.goalSectionMobile
                        : styles.goalSection,
                      stackRows && styles.stackedCol,
                    ]}>
                    <View
                      style={[
                        styles.cardHeading,
                        {
                          alignItems: isMobileOrTab ? 'flex-start' : 'center',
                          justifyContent: 'space-between',
                          flexWrap: 'wrap',
                        },
                      ]}>
                      <View style={{flexDirection: 'row', alignItems: 'center'}}>
                        <Box
                          style={[
                            styles.bullseye,
                            {
                              width: isMobileOrTab ? 33 : 40,
                              height: isMobileOrTab ? 33 : 40,
                            },
                          ]}>
                          <Image
                            source={dsIcons.gameAnalytics}
                            style={{width: 20, height: 20}}
                            resizeMode="contain"
                          />
                        </Box>

                        <View style={styles.cardHeadingTextContainer}>
                          <CCText
                            fontSize={FontSizes[16]}
                            style={[
                              styles.cardHeadingText,
                              {paddingVertical: 0, ...OPACITY},
                            ]}>
                            Your Goals Progress
                          </CCText>
                          <CCText
                            fontSize={FontSizes[14]}
                            style={[
                              styles.cardHeadingSubText,
                              isMobileOrTab && styles.cardHeadingSubTextMobile,
                              {...OPACITY},
                            ]}>
                            See how you’re performing against your goals
                          </CCText>
                        </View>
                      </View>
                      {data?.target_accuracy ? (
                        <View style={styles.goalsTargetPill}>
                          <CCText fontSize={12} fontWeight="600">
                            🎯 Target: {data?.target_accuracy}%
                          </CCText>
                        </View>
                      ) : null}
                    </View>
                    <View
                      style={
                        isMobileOrTab
                          ? styles.goalsMobileContainer
                          : styles.goalsContainer
                      }>
                      {goal(
                        'Blunder free games',
                        'last 10 games',
                        'Percentage of your last 10 games where you committed zero blunders',
                        `${perfStatsAvg?.blunder_free_games}`,
                        {
                          isFirst: true,
                        },
                        null,
                        <Image
                          source={dsIcons.gameAnalytics}
                          style={{height: 21, width: 21}}
                          resizeMode="contain"
                        />,
                        CCColors.Red,
                      )}
                      {goal(
                        'Blunders under 10s',
                        'last 10 games',
                        'Percentage of your last 10 blunders where you spent less than 10 seconds before making the move',
                        isNaN(perfStatsAvg.blunders_in_less_than_ten_secs)
                          ? '-'
                          : `${perfStatsAvg.blunders_in_less_than_ten_secs}`,
                        undefined,
                        undefined,
                        <Image
                          source={dsIcons.chessEvents}
                          style={{height: 21, width: 21}}
                          resizeMode="contain"
                        />,
                        '#D1AB41',
                      )}
                      {goal(
                        'Positions on 1st try',
                        data?.perf_stats.puzzles_on_first_try_last_n.length > 0
                          ? `last ${data?.perf_stats.puzzles_on_first_try_last_n.length} positions`
                          : '',
                        'Percentage of the last 10 positions you solved in the first attempt!',
                        isNaN(puzzleOnFirstTryScore)
                          ? '-'
                          : `${puzzleOnFirstTryScore}`,
                        isNaN(puzzleOnFirstTryScore) && {
                          action: {
                            text: 'Start solving',
                            handler: () => {
                              navigation.navigate(ScreenName.Puzzles);
                            },
                          },
                        },
                        undefined,
                        <Image
                          source={dsIcons.positionsTrainer}
                          style={{height: 21, width: 21}}
                          resizeMode="contain"
                        />,
                        CCColors.Green,
                      )}
                      {goal(
                        'Accuracy in games',
                        'last 10 games',
                        'Your average accuracy in last 10 games',
                        `${perfStatsAvg.accuracy}`,
                        {
                          isLast: true,
                        },
                        data?.target_accuracy,
                        <Image
                          source={dsIcons.calculationTrainer}
                          style={{height: 21, width: 21}}
                          resizeMode="contain"
                        />,
                        CCColors.Green,
                      )}
                    </View>
                    {false && (
                      <Box style={styles.reportsStrip}>
                        <Box type="row-flex-start">
                          <Box style={styles.circleContainer}>
                            <MaterialIcons
                              name="bar-chart"
                              size={25}
                              color="#fff"
                            />
                          </Box>
                          <Spacer spacing={10} horizontal />
                          <CCText>
                            Dive deep into a comprehensive analysis of your
                            gameplay
                          </CCText>
                        </Box>
                        <CCButton
                          onPress={() => {
                            navigation.navigate(ScreenName.Reports);
                          }}>
                          <CCText>View reports</CCText>
                        </CCButton>
                      </Box>
                    )}
                  </View>

                  <View
                    style={[
                      styles.card,
                      isMobileOrTab
                        ? styles.assessmentSectionMobile
                        : styles.assessmentSection,
                      stackRows && styles.stackedCol,
                    ]}>
                    {isMobileOrTab && <Spacer spacing={20} />}
                    <View style={[styles.cardHeading]}>
                      <Box
                        style={{
                          backgroundColor: '#E9F3FF',
                          height: isMobileOrTab ? 33 : 40,
                          width: isMobileOrTab ? 33 : 40,
                          borderRadius: '50%',
                          justifyContent: 'center',
                          alignItems: 'center',
                        }}>
                        <Image
                          source={dsIcons.assessment}
                          style={{height: 21, width: 21}}
                          resizeMode="contain"
                        />
                      </Box>
                      <CCText
                        fontSize={FontSizes[16]}
                        style={[styles.cardHeadingText, {...OPACITY}]}>
                        Last {data?.assessment?.games_count || 25}-Games
                        Assessment
                      </CCText>
                    </View>
                    <View
                      style={{flexGrow: 1, justifyContent: 'flex-start'}}>
                      <View style={styles.assessmentScoreContainer}>
                        <View style={styles.assessmentMainScore}>
                          <CustomInfoBox
                            text={calculationTooltip}
                            customView={
                              <>
                                <CCText
                                  fontSize={FontSizes[24]}
                                  style={[
                                    styles.assessmentScore,
                                    {...OPACITY},
                                  ]}>
                                  {Number(
                                    data?.assessment?.score?.calculation_depth,
                                  )
                                    ? data?.assessment?.score?.calculation_depth.toFixed(
                                        2,
                                      )
                                    : '-'}
                                </CCText>
                                <CCText
                                  style={[
                                    styles.assessmentBottomLabel,
                                    {...OPACITY},
                                  ]}>
                                  Calculation
                                </CCText>
                              </>
                            }
                          />
                        </View>
                        <View style={styles.assessmentMainScore}>
                          <CustomInfoBox
                            text={openingTooltip}
                            customView={
                              <>
                                <CCText
                                  fontSize={FontSizes[24]}
                                  style={[
                                    styles.assessmentScore,
                                    {...OPACITY},
                                  ]}>
                                  {Math.floor(
                                    data?.assessment?.score?.opening,
                                  ) || 0}
                                  <CCText
                                    fontWeight="500"
                                    size={12}
                                    color={CCColors.TextColor.Grey}>
                                    %
                                  </CCText>
                                </CCText>
                                <CCText
                                  style={[
                                    styles.assessmentBottomLabel,
                                    {...OPACITY},
                                  ]}>
                                  Opening
                                </CCText>
                              </>
                            }
                          />
                        </View>
                        <View style={styles.assessmentMainScore}>
                          <CustomInfoBox
                            text={middleGameTooltip}
                            customView={
                              <>
                                <CCText
                                  fontSize={FontSizes[24]}
                                  style={[
                                    styles.assessmentScore,
                                    {...OPACITY},
                                  ]}>
                                  {Math.floor(
                                    data?.assessment?.score?.middlegame,
                                  ) || 0}
                                  <CCText
                                    fontWeight="500"
                                    size={12}
                                    color={CCColors.TextColor.Grey}>
                                    %
                                  </CCText>
                                </CCText>
                                <CCText
                                  style={[
                                    styles.assessmentBottomLabel,
                                    {...OPACITY},
                                  ]}>
                                  Middlegame
                                </CCText>
                              </>
                            }
                          />
                        </View>
                        <View
                          style={[
                            styles.assessmentMainScore,
                            {borderRightWidth: 0},
                          ]}>
                          <CustomInfoBox
                            text={endgameTooltip}
                            customView={
                              <>
                                <CCText
                                  fontSize={FontSizes[24]}
                                  style={[
                                    styles.assessmentScore,
                                    {...OPACITY},
                                  ]}>
                                  {isNaN(data?.assessment?.score?.endgame)
                                    ? data?.assessment?.score?.endgame || 0
                                    : Math.floor(
                                        data?.assessment?.score?.endgame,
                                      ) || 0}
                                  <CCText
                                    fontWeight="500"
                                    size={12}
                                    color={CCColors.TextColor.Grey}>
                                    %
                                  </CCText>
                                </CCText>
                                <CCText
                                  style={[
                                    styles.assessmentBottomLabel,
                                    {...OPACITY},
                                  ]}>
                                  Endgame
                                </CCText>
                              </>
                            }
                          />
                        </View>
                      </View>
                      {/* {!isPremiumUser && ( */}
                      <RunAssessment
                        withContentStyle
                        onLoadingChange={loading =>
                          setIsAssessmentLoading(loading)
                        }
                      />
                      {/* )} */}

                      <View
                        style={{
                          marginTop: 10,
                        }}>
                        <CCButton
                          // type="none"
                          style={{}}
                          animated
                          onPress={() => {
                            if (data?.user.learning_onboarding_status === 1) {
                              navigation.navigate(ScreenName.AssessmentReport, {
                                id: data?.assessment.id,
                                // openingGamePercentage:
                                //   data?.assessment?.score?.opening,
                                // middleGamePercentage:
                                //   data?.assessment?.score?.middlegame,
                                // endGamePercentage:
                                //   data?.assessment?.score?.endgame,
                                // calculationDepthPercentage:
                                //   data?.assessment?.score?.calculation_depth,
                              });
                            }
                          }}
                          contentContainerStyle={{
                            paddingHorizontal: 0,
                            paddingVertical: 8,

                            flexDirection: 'row',
                          }}>
                          <CCText fontWeight={500} fontSize={FontSizes[14]}>
                            View Full report
                          </CCText>
                          {/* Offset from Run assessment's arrow above so the
                              two stacked CTAs don't nudge in unison. */}
                          <NudgeArrow
                            fontSize={FontSizes[14]}
                            delay={500}
                            style={{marginLeft: 6}}
                          />
                          {/* <Box flexDirection="row" justifyContent="space-between">
                      <CCText
                        fontSize={FontSizes[16]}
                        fontWeight="500"
                        style={[{marginRight: 16, ...OPACITY}]}>
                        <CCText
                          fontSize={FontSizes[16]}
                          fontWeight="500"
                          style={[
                            {
                              marginRight: 8,
                              alignSelf: 'flex-start',
                              ...OPACITY,
                            },
                          ]}
                          color="#67B3E1">
                          ▪
                        </CCText>
                        Full report
                      </CCText>
                      <MaterialCommunityIcon
                        name="arrow-top-right"
                        size={16}
                        color={CCColors.Primary.Brown}
                      />
                    </Box> */}
                        </CCButton>
                        <Spacer spacing={10} />
                      </View>
                      <Box alignItems="center">
                        <CCText
                          fontWeight="500"
                          fontSize={FontSizes[12]}
                          textAlign="right"
                          color={CCColors.TextColor.Grey}>
                          Last updated on{' '}
                          {latestAssessmentDate || assessmentDate}
                        </CCText>
                      </Box>
                    </View>
                  </View>
                  {isMobileOrTab && <Spacer spacing={10} />}
                </View>
              )}
            </View>
            </Reveal>

            {/* <View style={styles.gameplayCards}>
        {GAMEPLAY_STRIP_CONTENT?.map(i => (
          <GamePlayStripComponent
            hoveredItemForGameplayCard={hoveredItemForGameplayCard}
            itemDetails={i}
            navigation={navigation}
          />
        ))}
      </View> */}
            {/* <View style={[styles.card, styles.reviewGameCard]}>
        <View
          style={[
            styles.cardHeading,
            {justifyContent: 'space-between', flexWrap: 'wrap'},
          ]}>
          <View style={{flexDirection: 'row', alignItems: 'center'}}>
            <MaterialCommunityIcon
              style={[
                styles.cardHeadingIcon,
                {backgroundColor: CCColors.Primary.Aqua},
              ]}
              name="cursor-default-click-outline"
              size={20}
              color="#fff"
            />
            <CCText style={[styles.cardHeadingText, OPACITY]}>
              Intuition Trainer
            </CCText>
          </View>
          {!isMobileOrTab && (
            <CCButton
              onPress={() => {
                navigation.navigate('VisualisationTrainer', {
                  selected: 'intuition',
                });
              }}
              style={styles.reviewGameAction}
              contentContainerStyle={{
                paddingRight: 8,
                paddingVertical: 8,
                paddingLeft: 32,
              }}>
              <View
                style={{
                  flex: 1,
                  justifyContent: 'space-between',
                  flexDirection: 'row',
                  alignItems: 'center',
                }}>
                <CCText style={[styles.reviewGameActionText, OPACITY]}>
                  Start Training
                </CCText>
              </View>
            </CCButton>
          )}
        </View>
        <View
          style={isMobileOrTab ? {} : {display: 'flex', flexDirection: 'row'}}>
          <View style={isMobileOrTab ? {width: '100%'} : {flex: 0.5}}>
            <ChessboardComponent
              disabled
              // boardOrientation={data?.game.color?.toLowerCase()}
              position={'5q2/4k3/1n6/8/2N5/4Q3/8/3K4 b - - 0 1'}
            />
          </View>
          <View style={styles.reviewGameDetails}>
            <View
              style={{
                flexDirection: 'column',
                alignItems: 'flex-start',
                flex: 1,
                justifyContent: 'space-evenly',
              }}>
              <CCText>
                Analyze your moves in detail, rectify your mistakes and earn
                100pts.
              </CCText>
              <View style={styles.reviewGameStatHeading}>
                <FontAwesome5
                  style={styles.reviewGameStatIcon}
                  name="user"
                  size={16}
                  color={CCColors.Red}
                />
                <CCText style={styles.intuitionTrainerHeadingText}>
                  Think like a grand master
                </CCText>
              </View>
              <View style={styles.reviewGameStatHeading}>
                <FontAwesome5
                  style={styles.reviewGameStatIcon}
                  name="user"
                  size={16}
                  color={CCColors.Red}
                />
                <CCText style={styles.intuitionTrainerHeadingText}>
                  Guest grand master’s move
                </CCText>
              </View>
              <View style={styles.reviewGameStatHeading}>
                <FontAwesome5
                  style={styles.reviewGameStatIcon}
                  name="user"
                  size={16}
                  color={CCColors.Red}
                />
                <CCText style={styles.intuitionTrainerHeadingText}>
                  Learn from master’s game
                </CCText>
              </View>

              {isMobileOrTab && (
                <Box style={{width: '100%'}}>
                  <Spacer spacing={10} />
                  <CCButton
                    onPress={() => {
                      navigation.navigate(ScreenName.ChessAnalysis, {
                        game_id: data?.game.uuid,
                        analyzed: data?.game?.analyzed,
                      });
                    }}
                    style={styles.reviewGameAction}
                    contentContainerStyle={{
                      paddingRight: 8,
                      paddingVertical: 8,
                      paddingLeft: 32,
                    }}>
                    <View
                      style={{
                        flex: 1,
                        justifyContent: 'space-between',
                        flexDirection: 'row',
                        alignItems: 'center',
                      }}>
                      <CCText style={styles.reviewGameActionText}>
                        Review
                      </CCText>
                      <CoinsChip style={styles.reviewGameActionCoinsContainer}>
                        <FontAwesome5 name="cursorClick" size={16} color="#D1AB41" />
                        <CCText
                          fontSize="12"
                          fontWeight="500"
                          style={{marginLeft: 8, lineHeight: 16}}>
                          Upto +
                          {(data?.game?.score?.total_puzzles -
                            data?.game?.score?.puzzles_solved) *
                            5 +
                            50}
                          pts
                        </CCText>
                      </CoinsChip>
                    </View>
                  </CCButton>
                </Box>
              )}
            </View>
          </View>
        </View>
      </View> */}
            <Reveal delay={180} style={styles.fullRow}>
            <View
              style={{
                flexDirection: stackRows ? 'column' : 'row',
                flexBasis: '100%',
                // Review game and Club activity sit as equal-height cards.
                // No gap: both cards carry margin 8, which already yields the
                // 16px gutter — a gap on top of that double-spaced them.
                alignItems: 'stretch',
              }}>
            <View
              style={[
                styles.card,
                styles.reviewGameCard,
                isMobileOrTab && styles.reviewGameCardMobile,
                // Column child: flex 0.7 would divide HEIGHT, not width.
                stackRows && styles.stackedCol,
              ]}>
              <View
                style={[
                  styles.cardHeading,
                  {justifyContent: 'space-between', flexWrap: 'wrap'},
                ]}>
                <View style={{flexDirection: 'row', alignItems: 'center'}}>
                  <Box
                    style={{
                      backgroundColor: '#FFEFEE',
                      height: 40,
                      width: 40,
                      borderRadius: '50%',
                      justifyContent: 'center',
                      alignItems: 'center',
                    }}>
                    <Image
                      source={dsIcons.gameAnalytics}
                      style={{height: 21, width: 21}}
                      resizeMode="contain"
                    />
                  </Box>

                  <CCText
                    fontSize={FontSizes[16]}
                    style={[styles.cardHeadingText, OPACITY]}>
                    Review game
                  </CCText>
                </View>
                {!isMobileOrTab && (
                  <CCButton
                    onPress={() => {
                      navigation.navigate(ScreenName.ChessAnalysis, {
                        game_id: data?.game.uuid,
                        analyzed: data?.game?.analyzed,
                      });
                    }}
                    style={[
                      styles.reviewGameAction,
                      isMobileOrTab && styles.reviewGameActionMobile,
                    ]}
                    contentContainerStyle={{
                      paddingRight: 8,
                      // paddingVertical: 8,
                      paddingLeft: 32,
                    }}>
                    <View
                      style={{
                        flex: 1,
                        justifyContent: 'space-between',
                        flexDirection: 'row',
                        alignItems: 'center',
                      }}>
                      <CCText style={[styles.reviewGameActionText, OPACITY]}>
                        Review
                      </CCText>
                      <CoinsChip style={styles.reviewGameActionCoinsContainer}>
                        <Image
                          source={coins}
                          style={{
                            height: 25,
                            width: 30,
                          }}
                        />

                        <CCText
                          fontSize="12"
                          fontWeight="500"
                          style={{marginLeft: 8, lineHeight: 16}}>
                          Upto +
                          {(data?.game?.score?.total_puzzles -
                            data?.game?.score?.puzzles_solved) *
                            5 +
                            50 || 0}
                          pts
                        </CCText>
                      </CoinsChip>
                    </View>
                  </CCButton>
                )}
              </View>
              <View
                style={
                  isMobileOrTab
                    ? // Design reviewBodyStyle (mobile): column, gap 16,
                      // margin-top 16. The board and the stats block were
                      // butting straight up against each other.
                      {display: 'flex', flexDirection: 'column', gap: 16}
                    : {display: 'flex', flexDirection: 'row'}
                }>
                <View
                  style={
                    isMobileOrTab ? {width: '100%'} : styles.reviewGameBoard
                  }>
                  <ChessboardComponent
                    disabled
                    boardOrientation={data.game?.color?.toLowerCase()}
                    position={sanitizeFEN(data.game?.fen)}
                    colorTheme={chessboardColorTheme}
                    showBoardNotation={false}
                  />
                </View>
                <View
                  style={[
                    styles.reviewGameDetails,
                    isMobileOrTab && styles.reviewGameDetailsMobile,
                  ]}>
                  <View
                    style={{
                      flexDirection: 'column',
                      // stretch, not flex-start: flex-start shrank the stat
                      // rows to their content so the card's right half sat
                      // empty. The rows are label-left/value-right pairs and
                      // need the full column width.
                      alignItems: 'stretch',
                      flex: 1,
                      justifyContent: 'space-between',
                    }}>
                    <View
                      style={{
                        display: 'flex',
                        alignSelf: 'stretch',
                      }}>
                      <View style={styles.reviewGameStat}>
                        <View style={styles.reviewGameStatHeading}>
                          <FontAwesome5
                            style={styles.reviewGameStatIcon}
                            name="user"
                            size={16}
                            color={CCColors.Red}
                          />
                          <CCText style={styles.reviewGameStatHeadingText}>
                            Opponent
                          </CCText>
                        </View>
                        <CCText style={styles.reviewGameStatText}>
                          {data?.game?.opponent} ({data?.game?.opponent_rating})
                        </CCText>
                      </View>

                      <View style={styles.reviewGameScoreStat}>
                        <CCText style={styles.reviewGameScoreStatHeadingText}>
                          Accuracy
                        </CCText>
                        <CCText style={styles.reviewGameScoreStatText}>
                          {data?.game?.accuracy?.toFixed(1)}
                        </CCText>
                      </View>
                      <View style={styles.reviewGameScoreStat}>
                        <CCText style={styles.reviewGameScoreStatHeadingText}>
                          First attempt positions solved
                        </CCText>
                        <CCText style={styles.reviewGameScoreStatText}>
                          {data?.game?.score?.first_attempt_bonus_puzzles}
                        </CCText>
                      </View>
                      <View style={styles.reviewGameScoreStat}>
                        <CCText style={styles.reviewGameScoreStatHeadingText}>
                          Blunders committed
                        </CCText>
                        <CCText style={styles.reviewGameScoreStatText}>
                          {data?.game?.score?.no_of_blunders}
                        </CCText>
                      </View>
                      <View style={styles.reviewGameScoreStat}>
                        <CCText style={styles.reviewGameScoreStatHeadingText}>
                          Quick Blunders (&lt;10 secs thought)
                        </CCText>
                        <CCText style={styles.reviewGameScoreStatText}>
                          {data?.game?.score?.blunder_in_less_than_ten_secs}
                        </CCText>
                      </View>
                      {data?.game?.score?.net_score > 0 && (
                        <View
                          style={[styles.reviewGameScoreStat, styles.top12]}>
                          <CCText
                            style={[
                              styles.reviewGameScoreStatHeadingText,
                              {color: CCColors.Green},
                            ]}>
                            You have scored:
                          </CCText>
                          <CCText
                            style={[
                              styles.reviewGameScoreStatText,
                              {color: CCColors.Green},
                            ]}>
                            +{data?.game?.score?.net_score}pts
                          </CCText>
                        </View>
                      )}
                      {data?.game?.score?.net_score < 0 && (
                        <View
                          style={[styles.reviewGameScoreStat, styles.top12]}>
                          <CCText
                            style={[
                              styles.reviewGameScoreStatHeadingText,
                              {color: CCColors.Red},
                            ]}>
                            You have lost:
                          </CCText>
                          <CCText
                            style={[
                              styles.reviewGameScoreStatText,
                              {color: CCColors.Red},
                            ]}>
                            {data?.game?.score?.net_score}pts
                          </CCText>
                        </View>
                      )}
                      <View style={styles.reviewGameScoreStat}>
                        <CCText style={styles.reviewGameScoreStatHeadingText}>
                          Earn upto &nbsp;
                          {(data?.game?.score?.total_puzzles -
                            data?.game?.score?.puzzles_solved) *
                            5 +
                            50}{' '}
                          pts.
                        </CCText>
                      </View>

                      {/* Accuracy + positions-solved meters. Both are values
                          already shown as bare numbers above — visualising
                          them fills the card instead of leaving dead space. */}
                      <View style={styles.reviewMeters}>
                        {Number(data?.game?.accuracy) > 0 && (
                          <View style={styles.reviewMeter}>
                            <View style={styles.reviewMeterLabelRow}>
                              <CCText
                                fontSize={11.5}
                                color={CCColors.TextColor.Grey}>
                                Accuracy this game
                              </CCText>
                              <CCText
                                fontSize={11.5}
                                fontWeight="bold"
                                color={CCColors.TextColor.Dark}>
                                {Number(data?.game?.accuracy).toFixed(1)}%
                              </CCText>
                            </View>
                            <AnimatedBar
                              percent={Number(data?.game?.accuracy)}
                              color={CCColors.Green}
                              trackColor={CCColors.Primary.lightBrown}
                              delay={120}
                            />
                          </View>
                        )}
                        {data?.game?.score?.total_puzzles > 0 && (
                          <View style={styles.reviewMeter}>
                            <View style={styles.reviewMeterLabelRow}>
                              <CCText
                                fontSize={11.5}
                                color={CCColors.TextColor.Grey}>
                                Positions solved
                              </CCText>
                              <CCText
                                fontSize={11.5}
                                fontWeight="bold"
                                color={CCColors.TextColor.Dark}>
                                {data?.game?.score?.puzzles_solved || 0} /{' '}
                                {data?.game?.score?.total_puzzles}
                              </CCText>
                            </View>
                            <AnimatedBar
                              percent={
                                ((data?.game?.score?.puzzles_solved || 0) /
                                  data?.game?.score?.total_puzzles) *
                                100
                              }
                              color="#D1AB41"
                              trackColor={CCColors.Primary.lightBrown}
                              delay={220}
                            />
                          </View>
                        )}
                      </View>
                    </View>
                    {isMobileOrTab && (
                      <Box style={{width: '100%'}}>
                        <Spacer spacing={10} />
                        <CCButton
                          onPress={() => {
                            navigation.navigate(ScreenName.ChessAnalysis, {
                              game_id: data?.game.uuid,
                              analyzed: data?.game?.analyzed,
                            });
                          }}
                          style={styles.reviewGameAction}
                          contentContainerStyle={{
                            paddingRight: 11,
                            paddingVertical: 4,
                            paddingLeft: 35,
                          }}>
                          <View
                            style={{
                              flex: 1,
                              justifyContent: 'space-between',
                              flexDirection: 'row',
                              alignItems: 'center',
                            }}>
                            <CCText style={styles.reviewGameActionText}>
                              Review
                            </CCText>
                            <CoinsChip style={styles.reviewGameActionCoinsContainer}>
                              <Image
                                source={coins}
                                style={{width: 20, height: 20}}
                              />
                              <CCText
                                fontSize="12"
                                fontWeight="500"
                                style={{marginLeft: 8, lineHeight: 16}}>
                                Upto +
                                {(data?.game?.score?.total_puzzles -
                                  data?.game?.score?.puzzles_solved) *
                                  5 +
                                  50 || 0}
                                pts
                              </CCText>
                            </CoinsChip>
                          </View>
                        </CCButton>
                      </Box>
                    )}
                  </View>
                </View>
              </View>
            </View>
            <ClubActivityCard persona={persona} stacked={stackRows} />
            </View>
            </Reveal>
            {/* Disabled on request: the "Live now" feed (design source
                DashboardRevampContent.dc.html `showLive` section). The
                component is kept at ./component/LiveActivityFeed — uncomment
                this block to bring it back.
            <Reveal delay={240} style={styles.fullRow}>
            <View style={{flexDirection: 'row', flexBasis: '100%'}}>
              <LiveActivityFeed />
            </View>
            </Reveal> */}

            {/* <View style={[styles.card, styles.reviewGameCard]}>
        <View
          style={[
            styles.cardHeading,
            {justifyContent: 'space-between', flexWrap: 'wrap'},
          ]}>
          <View style={{flexDirection: 'row', alignItems: 'center'}}>
            <MaterialCommunityIcon
              style={[styles.cardHeadingIcon, {backgroundColor: CCColors.Red}]}
              name="magnify"
              size={20}
              color="#fff"
            />
            <CCText style={[styles.cardHeadingText, OPACITY]}>
              Review game
            </CCText>
          </View>
          {!isMobileOrTab && (
            <CCButton
              onPress={() => {
                navigation.navigate(ScreenName.ChessAnalysis, {
                  game_id: data?.game.uuid,
                  analyzed: data?.game?.analyzed,
                });
              }}
              style={styles.reviewGameAction}
              contentContainerStyle={{
                paddingRight: 8,
                paddingVertical: 8,
                paddingLeft: 32,
              }}>
              <View
                style={{
                  flex: 1,
                  justifyContent: 'space-between',
                  flexDirection: 'row',
                  alignItems: 'center',
                }}>
                <CCText style={[styles.reviewGameActionText, OPACITY]}>
                  Review
                </CCText>
                <CoinsChip style={styles.reviewGameActionCoinsContainer}>
                  <FontAwesome5 name="coins" size={16} color="#D1AB41" />
                  <CCText
                    fontSize="12"
                    fontWeight="500"
                    style={{marginLeft: 8, lineHeight: 16}}>
                    Upto +
                    {(data?.game?.score?.total_puzzles -
                      data?.game?.score?.puzzles_solved) *
                      5 +
                      50}
                    pts
                  </CCText>
                </CoinsChip>
              </View>
            </CCButton>
          )}
        </View>
        <View
          style={isMobileOrTab ? {} : {display: 'flex', flexDirection: 'row'}}>
          <View style={isMobileOrTab ? {width: '100%'} : {flex: 0.5}}>
            <ChessboardComponent
              disabled
              boardOrientation={data?.game.color?.toLowerCase()}
              position={data?.game.fen}
            />
          </View>
          <View style={styles.reviewGameDetails}>
            <View
              style={{
                flexDirection: 'column',
                alignItems: 'flex-start',
                flex: 1,
                justifyContent: 'space-between',
              }}>
              <View
                style={{
                  display: 'flex',
                }}>
                <View style={styles.reviewGameStat}>
                  <View style={styles.reviewGameStatHeading}>
                    <FontAwesome5
                      style={styles.reviewGameStatIcon}
                      name="user"
                      size={16}
                      color={CCColors.Red}
                    />
                    <CCText style={styles.reviewGameStatHeadingText}>
                      Opponent
                    </CCText>
                  </View>
                  <CCText style={styles.reviewGameStatText}>
                    {data?.game.opponent} ({data?.game.opponent_rating})
                  </CCText>
                </View>

                <View style={styles.reviewGameScoreStat}>
                  <CCText style={styles.reviewGameScoreStatHeadingText}>
                    Accuracy
                  </CCText>
                  <CCText style={styles.reviewGameScoreStatText}>
                    {data?.game?.accuracy?.toFixed(1)}
                  </CCText>
                </View>
                <View style={styles.reviewGameScoreStat}>
                  <CCText style={styles.reviewGameScoreStatHeadingText}>
                    First attempt positions solved
                  </CCText>
                  <CCText style={styles.reviewGameScoreStatText}>
                    {data?.game?.score?.first_attempt_bonus_puzzles}
                  </CCText>
                </View>
                <View style={styles.reviewGameScoreStat}>
                  <CCText style={styles.reviewGameScoreStatHeadingText}>
                    Blunders committed
                  </CCText>
                  <CCText style={styles.reviewGameScoreStatText}>
                    {data?.game?.score?.no_of_blunders}
                  </CCText>
                </View>
                <View style={styles.reviewGameScoreStat}>
                  <CCText style={styles.reviewGameScoreStatHeadingText}>
                    Quick Blunders (&lt;10 secs thought)
                  </CCText>
                  <CCText style={styles.reviewGameScoreStatText}>
                    {data?.game?.score?.blunder_in_less_than_ten_secs}
                  </CCText>
                </View>
                {data?.game?.score?.net_score > 0 && (
                  <View style={[styles.reviewGameScoreStat, styles.top12]}>
                    <CCText
                      style={[
                        styles.reviewGameScoreStatHeadingText,
                        {color: CCColors.Green},
                      ]}>
                      You have scored:
                    </CCText>
                    <CCText
                      style={[
                        styles.reviewGameScoreStatText,
                        {color: CCColors.Green},
                      ]}>
                      +{data?.game?.score?.net_score}pts
                    </CCText>
                  </View>
                )}
                {data?.game?.score?.net_score < 0 && (
                  <View style={[styles.reviewGameScoreStat, styles.top12]}>
                    <CCText
                      style={[
                        styles.reviewGameScoreStatHeadingText,
                        {color: CCColors.Red},
                      ]}>
                      You have lost:
                    </CCText>
                    <CCText
                      style={[
                        styles.reviewGameScoreStatText,
                        {color: CCColors.Red},
                      ]}>
                      {data?.game?.score?.net_score}pts
                    </CCText>
                  </View>
                )}
                <View style={styles.reviewGameScoreStat}>
                  <CCText style={styles.reviewGameScoreStatHeadingText}>
                    Earn upto &nbsp;
                    {(data?.game?.score?.total_puzzles -
                      data?.game?.score?.puzzles_solved) *
                      5 +
                      50}{' '}
                    pts.
                  </CCText>
                </View>
              </View>
              {isMobileOrTab && (
                <Box style={{width: '100%'}}>
                  <Spacer spacing={10} />
                  <CCButton
                    onPress={() => {
                      navigation.navigate(ScreenName.ChessAnalysis, {
                        game_id: data?.game.uuid,
                        analyzed: data?.game?.analyzed,
                      });
                    }}
                    style={styles.reviewGameAction}
                    contentContainerStyle={{
                      paddingRight: 8,
                      paddingVertical: 8,
                      paddingLeft: 32,
                    }}>
                    <View
                      style={{
                        flex: 1,
                        justifyContent: 'space-between',
                        flexDirection: 'row',
                        alignItems: 'center',
                      }}>
                      <CCText style={styles.reviewGameActionText}>
                        Review
                      </CCText>
                      <CoinsChip style={styles.reviewGameActionCoinsContainer}>
                        <FontAwesome5 name="coins" size={16} color="#D1AB41" />
                        <CCText
                          fontSize="12"
                          fontWeight="500"
                          style={{marginLeft: 8, lineHeight: 16}}>
                          Upto +
                          {(data?.game?.score?.total_puzzles -
                            data?.game?.score?.puzzles_solved) *
                            5 +
                            50}
                          pts
                        </CCText>
                      </CoinsChip>
                    </View>
                  </CCButton>
                </Box>
              )}
            </View>
          </View>
        </View>
      </View> */}

            {/* DONT REMOVE THIS COMMENT, MIGHT BE NEEDED LATER */}
            {/* <View style={[styles.card, styles.masterGameCard]}>
        <View
          style={[
            styles.cardHeading,
            {justifyContent: 'space-between', flexWrap: 'wrap'},
          ]}>
          <View
            style={{
              flexDirection: 'row',
              alignItems: 'center',
            }}>
            <MaterialCommunityIcon
              style={[
                styles.cardHeadingIcon,
                {backgroundColor: CCColors.Green},
                isMobileOrTab ? {} : {paddingBottom: 2},
              ]}
              name="puzzle-outline"
              size={20}
              color="#fff"
            />
            <CCText style={styles.cardHeadingText}>
              Positions from Masters’ games
            </CCText>
          </View>
          {!isMobileOrTab && (
            <CCButton
              style={styles.masterGameAction}
              onPress={() => {
                navigation.navigate(ScreenName.Puzzles, {is_masters: true});
              }}
              contentContainerStyle={{
                paddingVertical: 10,
                paddingHorizontal: 24,
              }}>
              <CCText fontWeight="500" fontSize="16">
                Solve
              </CCText>
            </CCButton>
          )}
        </View>

        <View style={styles.masterGameContent}>
          <View style={styles.masterGamePlayer}>
            <View style={styles.masterGamePlayerPhotoContainer}>
              <Image
                style={styles.masterGamePlayerPhoto}
                source={
                  data?.master_puzzle.user_photo_url
                    ? {uri: data?.master_puzzle.user_photo_url}
                    : require('@/Assets/Images/Svgs/silhouette-male-icon.svg')
                }
              />
              <CCText style={styles.masterGamePlayerTitle}>GM</CCText>
            </View>
            <CCText style={styles.masterGamePlayerName}>{parts[0]}</CCText>
            <CCText style={styles.masterGamePlayerRating}>
              {data?.master_puzzle.user_rating
                ? data?.master_puzzle.user_rating
                : 2830}
            </CCText>
          </View>
          {isMobileOrTab && <Divider isVertical style={{height: '100%'}} />}
          {!isMobileOrTab && (
            <View style={styles.masterGameBoard}>
              <ChessboardComponent
                disabled
                boardOrientation="white"
                lastMoveFen={data?.master_puzzle.previous_fen}
                position={data?.master_puzzle.fen}
              />
            </View>
          )}

          <View style={styles.masterGamePlayer}>
            <View style={styles.masterGamePlayerPhotoContainer}>
              <Image
                style={styles.masterGamePlayerPhoto}
                source={
                  data?.master_puzzle.opponent_photo_url
                    ? {uri: data?.master_puzzle.opponent_photo_url}
                    : require('@/Assets/Images/Svgs/silhouette-male-icon.svg')
                }
              />
              <CCText style={styles.masterGamePlayerTitle}>GM</CCText>
            </View>
            <CCText style={styles.masterGamePlayerName}>
              {data?.master_puzzle.opponent}
            </CCText>
            <CCText style={styles.masterGamePlayerRating}>
              {data?.master_puzzle.opponent_rating
                ? data?.master_puzzle.opponent_rating
                : 2830}
            </CCText>
          </View>
        </View>
        {isMobileOrTab && (
          <>
            <View style={styles.masterGameBoard}>
              <ChessboardComponent
                disabled
                boardOrientation="white"
                lastMoveFen={data?.master_puzzle.previous_fen}
                position={data?.master_puzzle.fen}
              />
            </View>
          </>
        )}
        <CCText style={styles.masterGameTournament}>
          {parts[1] ? parts[1] : 'Rapid Blitz Tournament, London, 2022'}
        </CCText>
        {isMobileOrTab && (
          <>
            <Spacer spacing={10} />
            <CCButton
              style={styles.masterGameAction}
              onPress={() => {
                navigation.navigate(ScreenName.Puzzles, {is_masters: true});
              }}
              contentContainerStyle={{
                paddingVertical: 10,
                paddingHorizontal: 24,
              }}>
              <CCText fontWeight="500" fontSize="16">
                Solve
              </CCText>
            </CCButton>
          </>
        )}
      </View> */}

            {/* My Scoreboard — disabled on request. The block is kept intact
                rather than deleted; flip `false` to re-enable. (A wrapping
                {...} JSX comment can't be used here: the block already
                contains a closing comment marker.) */}
            {false && (
            <Reveal delay={300} style={styles.fullRow}>
            <View style={{flexDirection: 'row', flexBasis: '100%'}}>
              <View style={[styles.card, styles.scoreboardCard]}>
                <View style={styles.cardHeading}>
                  <MaterialCommunityIcon
                    style={[
                      styles.cardHeadingIcon,
                      {backgroundColor: '#937ADB'},
                    ]}
                    name="clipboard-outline"
                    size={20}
                    color="#fff"
                  />
                  <CCText
                    fontSize={FontSizes[16]}
                    style={[styles.cardHeadingText, OPACITY]}>
                    My Scoreboard
                  </CCText>
                </View>

                {!isMobileOrTab && (
                  <View style={{height: 36, flexDirection: 'row'}}>
                    <CCText
                      fontSize={FontSizes[15]}
                      textAlign="center"
                      style={{flex: 1}}>
                      Game Play Performance
                    </CCText>
                    <CCText
                      fontSize={FontSizes[15]}
                      textAlign="center"
                      style={{flex: 1}}>
                      Game Review Performance
                    </CCText>
                  </View>
                )}
                <Divider />
                <View style={[styles.scoreboardTable, {margin: 0}]}>
                  {isMobileOrTab && (
                    <CCPackageTableNew
                      color={CCColors.White}
                      headers={[
                        'Date',
                        'Played',
                        'Blunder free games',
                        'No. of Blunders',
                        'Average Accuracy',
                        'Reviewed',
                        'First Attempt Solves',
                        'You scored',
                        '',
                      ]}
                      separator={true}
                      customHeader={{
                        color: CCColors.TextColor.Grey,
                      }}
                      tableData={scorecards?.slice(0, 5)?.map(({fields}, i) => [
                        {name: colText(fields.score_date), type: 'text'},
                        {
                          name: colText(
                            <View style={{flexDirection: 'row'}}>
                              <CCText
                                style={{color: CCColors.Primary.Brown}}
                                fontSize={FontSizes[15]}
                                fontWeight="500">
                                {fields.games_played}
                              </CCText>
                            </View>,
                          ),
                          type: 'text',
                        },
                        {
                          name: colText(fields.zero_blunder_games),
                          type: 'text',
                        },
                        {name: colText(fields.no_of_blunders), type: 'text'},
                        {
                          name: colText(fields.average_accuracy?.toFixed(1)),
                          type: 'text',
                        },
                        {
                          name: colText(
                            <View style={{flexDirection: 'row'}}>
                              <CCText
                                style={{color: CCColors.Primary.Brown}}
                                fontSize={FontSizes[15]}
                                fontWeight="500">
                                {fields.games_analyzed}
                              </CCText>
                              {/* {fields['games_played'] != fields['games_analyzed'] && (
            <CCText
              fontWeight="500"
              fontSize={12}
              color={CCColors.TextColor.Grey}
              style={{marginLeft: 8, alignSelf: 'center'}}>
              {fields['games_played'] - fields['games_analyzed']}{' '}
              remaining
            </CCText>
          )} */}
                            </View>,
                          ),
                          type: 'text',
                        },
                        {
                          name: colText(fields.first_attempt_puzzles_solved),
                          type: 'text',
                        },
                        {name: colText(fields.net_score), type: 'text'},
                        {
                          name: colText(
                            <CCButton
                              type="none"
                              style={styles.scoreboardReviewButton}
                              onPress={() => {
                                navigation.navigate(ScreenName.Games, {
                                  filter_date: fields.score_date,
                                });
                              }}
                              contentContainerStyle={{
                                paddingHorizontal: 16,
                                paddingVertical: 0,
                              }}>
                              <CCText
                                fontSize={FontSizes[15]}
                                fontWeight="500"
                                color="#3DAB9E">
                                Review
                              </CCText>
                            </CCButton>,
                          ),
                          type: 'text',
                        },
                        // {name: game?.sms_sent_timestamp?.slice(0, 10), type: 'text'},
                      ])}
                      rowProps={{
                        widthArr: [
                          '7vw',
                          '25vw',
                          '7vw',
                          '5vw',
                          '7vw',
                          '4vw',
                          '5vw',
                          '7vw',
                          '7vw',
                          '12vw',
                        ],
                      }}
                      cellProps={{
                        numberOfLines: 2, // Adjust the number of lines as needed
                        multiline: true, // Enable multiline text within cells
                      }}
                    />
                  )}
                  {!isMobileOrTab && (
                    <View style={{flexDirection: 'row', margin: 0}}>
                      <Box margin={0} flex={1} overflow="hidden">
                        <View style={[styles.tableRow, styles.tableHeader]}>
                          <Box flex={1} flexDirection="row">
                            {headerColText('Date')}
                            {headerColText('Played')}
                            {headerColText('Blunder free games')}
                            {headerColText('No. of Blunders')}
                            {headerColText('Average Accuracy')}
                          </Box>
                          <Divider isVertical />
                          <Box flex={1} flexDirection="row">
                            {headerColText('Reviewed')}
                            {headerColText('First Attempt Solves')}
                            {headerColText('You scored')}
                            {headerColText('')}
                          </Box>
                        </View>
                        {scorecards?.slice(0, 5).map(({fields}, i) => {
                          return (
                            <View
                              style={[
                                styles.tableRow,
                                i % 2 == 1 && {
                                  backgroundColor: updateColorWithOpacity(
                                    CCColors.Primary.Light,
                                    0.5,
                                  ),
                                },
                              ]}>
                              <Box flex={1} flexDirection="row">
                                {colText(fields.score_date)}
                                {colText(
                                  <View style={{flexDirection: 'row'}}>
                                    <CCText fontWeight="500">
                                      {fields.games_played}
                                    </CCText>
                                  </View>,
                                )}
                                {colText(fields.zero_blunder_games)}
                                {colText(fields.no_of_blunders)}
                                {colText(fields.average_accuracy.toFixed(1))}
                              </Box>
                              <Divider isVertical />
                              <Box flex={1} flexDirection="row">
                                {colText(
                                  <View style={{flexDirection: 'row'}}>
                                    <CCText fontWeight="500">
                                      {fields.games_analyzed}
                                    </CCText>
                                  </View>,
                                )}
                                {colText(fields.first_attempt_puzzles_solved)}
                                {colText(fields.net_score)}
                                {colText(
                                  <CCButton
                                    type="none"
                                    style={styles.scoreboardReviewButton}
                                    onPress={() => {
                                      navigation.navigate(ScreenName.Games, {
                                        filter_date: fields.score_date,
                                      });
                                    }}
                                    contentContainerStyle={{
                                      paddingHorizontal: 16,
                                      paddingVertical: 0,
                                    }}>
                                    <CCText fontWeight="500" color="#3DAB9E">
                                      Review
                                    </CCText>
                                  </CCButton>,
                                )}
                              </Box>
                            </View>
                          );
                        })}
                      </Box>
                    </View>
                  )}
                </View>
              </View>
            </View>
            </Reveal>
            )}
          </>
        )}
      </View>
      {/* Disabled: forced users straight into an ImportGames detour right
          after OTP login instead of letting them land directly on the
          dashboard. Kept here (not deleted) in case we want it back.
      <ConnectionModal
        visible={data.user.learning_onboarding_status === 3}
        onContinue={() => {
          navigation.navigate(ScreenName.ImportGames);
        }}
        onClose={() => {}}
        onboarding_completed={false}
      /> */}
    </Box>
  );
}

export default React.memo(Dashboard);
